import { https } from "../http";
import store from "../store";
import {
  setLoading,
  setDashboardCounts,
  setDashboardNotes,
  setStaffDashboardCounts,
  setStaffLoadingCount,
  setDashboardPendingNotes,
  setDashboardTasks,
  setDashboardPendingNotesLoading,
  setDashboardPendingActions,
  setDashboardPendingActionsLoading,
  setDashboardTasksSkypoint,
  setDashboardTasksSkypointLoading,
  setDashboardMetricsLoading,
  setDashboardMetrics,
} from "../store/reducers/dashboard";
import { showError } from "../utils/index";

// GET
const getDashboardCounts = async (showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));
    let response = await https().get(`/me/dashboard`);
    if (response?.status === 200) {
      store.dispatch(setDashboardCounts(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getSkypointDashboardCounts = async (showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));
    let response = await https().get(`/me/skypoint/dashboard`);
    if (response?.status === 200) {
      store.dispatch(setDashboardCounts(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// POST /me/staff-dashboard
const getStaffDashboardCounts = async (date, showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setStaffLoadingCount(true));
    let response = await https().post(`/me/staff-dashboard`, date);
    if (response?.status === 200) {
      store.dispatch(setStaffDashboardCounts(response?.data));
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  } finally {
    store.dispatch(setStaffLoadingCount(false));
  }
};

const getPendingNotes = async (page, showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setDashboardPendingNotesLoading(true));
    let response = await https().get(`/note/dashboard/pandingNotes`);
    if (response?.status === 200) {
      store.dispatch(setDashboardPendingNotes(response?.data?.data));
      store.dispatch(setDashboardPendingNotesLoading(false));
    }
  } catch (error) {
    store.dispatch(setDashboardPendingNotesLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};
const getTodaysNotes = async (data, showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));
    let response = await https().get(
      `/note?page=all&date=today&search=${data}`
    );

    if (response?.status === 200) {
      store.dispatch(setDashboardNotes(response?.data?.notes));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getTodaysTasks = async (data, startDate, endDate, showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));
    let response = await https().get(
      `/task/get-tasks?page=1&perPage=10&status=all&date=today&search=${data}&startDate=${startDate}&endDate=${endDate}`
    );
    if (response?.status === 200) {
      store.dispatch(setDashboardTasks(response?.data?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getPendingActions = async (page = 1, limit = 20) => {
  try {
    store.dispatch(setDashboardPendingActionsLoading(true));

    const response = await https().get(`/note/dashboard/pending-actions?page=${page}&limit=${limit}`);

    if (response?.status === 200) {
      store.dispatch(setDashboardPendingActions(response.data));
      store.dispatch(setDashboardPendingActionsLoading(false));
      return response.data;
    }
  } catch (error) {
    store.dispatch(setDashboardPendingActionsLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getPendingActionsSkypoint = async (page = 1, limit = 20) => {
  try {
    store.dispatch(setDashboardPendingActionsLoading(true));

    const response = await https().get(`/note/dashboard/skypoint-pending-actions?page=${page}&limit=${limit}`);

    if (response?.status === 200) {
      store.dispatch(setDashboardPendingActions(response.data));
      store.dispatch(setDashboardPendingActionsLoading(false));
      return response.data;
    }
  } catch (error) {
    store.dispatch(setDashboardPendingActionsLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const clearPendingActionsSkypoint = async () => {
  try {
    const response = await https().post(
      `/note/dashboard/skypoint-pending-actions/clear`
    );
    if (response?.status === 200) return response.data;
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return null;
  }
};

const getDashboardProjectTasksSkypoint = async (
  page = 1,
  search = "",
  showLoading = true
) => {
  try {
    const strUrl = `/skypointProject/dashboard/${page}${
      search ? `?search=${search}` : ""
    }`;
    if (showLoading) store.dispatch(setDashboardTasksSkypointLoading(true));
    let response = await https().get(strUrl);
    if (response?.status === 200) {
      store.dispatch(setDashboardTasksSkypoint(response?.data));
    }
  } catch (error) {
    store.dispatch(setDashboardTasksSkypointLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getSkypointDashboardMetrics = async (params = {}) => {
  try {
    store.dispatch(setDashboardMetricsLoading(true));
    const response = await https().post(`/me/skypoint/dashboard-metrics`, {
      trendPeriod: params.trendPeriod || 30,
      providerTablePage: params.providerTablePage || 1,
      providerTableSearch: params.providerTableSearch || "",
    });
    if (response?.status === 200) {
      store.dispatch(setDashboardMetrics(response?.data));
      return response?.data;
    }
  } catch (error) {
    store.dispatch(setDashboardMetricsLoading(false));
  }
};

export {
  getDashboardCounts,
  getTodaysNotes,
  getStaffDashboardCounts,
  getPendingNotes,
  getTodaysTasks,
  getPendingActions,
  getPendingActionsSkypoint,
  clearPendingActionsSkypoint,
  getSkypointDashboardCounts,
  getDashboardProjectTasksSkypoint,
  getSkypointDashboardMetrics,
};
